import { render, staticRenderFns } from "./contactUpComponent.vue?vue&type=template&id=01814d86&scoped=true&"
import script from "./contactUpComponent.vue?vue&type=script&lang=js&"
export * from "./contactUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./contactUpComponent.vue?vue&type=style&index=0&id=01814d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01814d86",
  null
  
)

export default component.exports